import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
// import Programming from './pages/Programming';
import Technical from './pages/Technical';
import Conductors from './pages/Conductors';
import LiveFrame from './pages/LiveFrame';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';

function MainApp() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Routes publiques */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Redirection racine vers login */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          
          {/* Routes protégées */}
          <Route element={<PrivateRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/technical" element={<Technical />} />
            <Route path="/conductors" element={<Conductors />} />
            <Route path="/live-view" element={<LiveFrame mode="view" />} />
            <Route path="/live-record" element={<LiveFrame mode="record" />} />
            <Route path="/live-admin" element={<LiveFrame mode="admin" />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default MainApp;
